export const HEIGHT_IMAGE_PRODUCT_ITEM_LIST = "150px"
export const SM_WIDTH_IMAGE_PRODUCT_ITEM_LIST = "120px"
export const XS_WIDTH_IMAGE_PRODUCT_ITEM_LIST = "150px"
/**
 * Used to replace radio check by box when in View mode
 */
export const RADIO_SIZE = 42;